/**
 * Design Module Routes (extracted from index.tsx)
 */
import React from 'react';
import { Result } from 'antd';
import { RouteItem } from './index';
import { HomeOutlined, FormOutlined, OrderedListOutlined, PlusOutlined, CloudOutlined, FolderOutlined } from '@ant-design/icons';

// Shared forms
import FormDefinitionsList from "../components/common/Forms/FormDefinitionsList";
import FormDefinitionEditor from "../components/common/Forms/FormDefinitionEditor";
import PdfToReactFormGenerator from "../components/common/Forms/PdfToReactFormGenerator";
import FormRecordDetailsList from '../components/common/Forms/FormRecordDetailsList';

// Design forms
import DsgnFormsCreate from "../pages/design/forms/DsgnFormsCreate";
import DsgnFormFill from "../pages/design/forms/DsgnFormFill";
import DsgnFormList from "../pages/design/forms/DsgnFormList";
import DsgnFormEdit from '../pages/design/forms/DsgnFormEdit';
import DsgnFormView from '../pages/design/forms/DsgnFormView';
import DsgnFormGroupCreate  from "../pages/design/forms/DsgnFormGroupCreate";

// ACC
import AccDashboard from '../pages/design/acc/AccDashboard';
import AccProjects from '../pages/design/acc/AccProjects';
import AccProjectDetail from '../pages/design/acc/AccProjectDetail';
import AccPdfViewer from '../pages/design/acc/AccPdfViewer';

const UnderConstruction = ({ title }: { title: string }) => (
  <Result status="info" title={`${title} Module`} subTitle="Under Construction." />
);

export const designRoutes: Record<string, RouteItem> = {
  // DESIGN modülü
  design: {path: '/design', element: null, label: 'Design', showInMenu: false,
    children: {
      dashboard: {path: '/design/dashboard', element: <UnderConstruction title="Design" />, label: 'Design', icon: <HomeOutlined />, showInMenu: true},
      forms: {path: '/design/forms', element: <DsgnFormList />, label: 'Forms', icon: <FormOutlined />, showInMenu: true,
        grandchildren: {
          list: {path: '/design/forms/list', element: <DsgnFormList/>, label: 'Form List', icon: <OrderedListOutlined />, showInMenu: true},
          definitions: {path: '/design/forms/definitions', element: <FormDefinitionsList />, label: 'Form Definitions', icon: <OrderedListOutlined />, showInMenu: true},
          definitions_create: {path: '/design/forms/definitions/create', element: <PdfToReactFormGenerator />, label: 'Create Form Definition', showInMenu: false},
          definitions_edit: {path: '/design/forms/definitions/edit/:id', element: <FormDefinitionEditor />, label: 'Edit Form Definition', showInMenu: false},
          list_record_details: {path: '/design/forms/list_record_details', element: <FormRecordDetailsList />, label: 'Form Record Details', icon: <OrderedListOutlined />, showInMenu: true},
          group: {path: '/design/forms/gr_create', element: <DsgnFormGroupCreate />, label: 'New Form Group', icon: <PlusOutlined />, showInMenu: true},
          create: {path: '/design/forms/create', element: <DsgnFormsCreate/>, label: 'Create Form', icon: <PlusOutlined />, showInMenu: true},
          fill: {path: '/design/forms/fill', element: <DsgnFormFill/>, label: 'Fill Form',  showInMenu: true},
          edit: {path: '/design/forms/edit/:id', element: <DsgnFormEdit />, label: 'Edit Form', showInMenu: false},
          view: {path: '/design/forms/view/:id', element: <DsgnFormView />, label: 'View Form', showInMenu: false},
        },
      },
      acc: {path: '/design/acc', element: null, label: 'ACC', icon: <CloudOutlined />, showInMenu: true,
        children: {
          dashboard: {path: '/design/acc/dashboard', element: <AccDashboard />, label: 'Dashboard', icon: <HomeOutlined />, showInMenu: true},
          projects: {path: '/design/acc/projects', element: <AccProjects />, label: 'Projects', icon: <FolderOutlined />, showInMenu: true},
          projectDetail: {path: '/design/acc/projects/:projectId', element: <AccProjectDetail />, label: 'Project Details', showInMenu: false},
          pdfViewer: {path: '/design/acc/pdf-viewer', element: <AccPdfViewer />, label: 'PDF Viewer', showInMenu: false},
        },
      },
    },
  },
};
